import React from 'react';
/** Announces validation errors to screen readers when they appear. */
export const SignUpFieldError = ({ id, show, children, 'data-test-id': dataTestId, }) => {
    if (!show || children == null || children === '') {
        return null;
    }
    return (<p id={id} role="alert" className="ui-form-helper-text ui-form-helper-text--error" data-test-id={dataTestId}>
      {children}
    </p>);
};
